import {
  Component,
  Input,
  Output,
  EventEmitter,
  CUSTOM_ELEMENTS_SCHEMA,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import type { LeafTextarea } from '@cigna/leaf-web/lib/wc/components/textarea/textarea';
import '@cigna/leaf-web/lib/wc/components/textarea/textarea';

@Component({
  selector: 'cigna-leaf-textarea',
  template: `
    <leaf-textarea
      [charLimit]="charLimit"
      [disabled]="disabled"
      [readonly]="readonly"
      [error]="error"
      [success]="success"
      [rows]="rows"
      [cols]="cols"
      [fieldNote]="fieldNote"
      [label]="label"
      [type]="type"
      [fieldId]="fieldId"
      [ariaDescribedBy]="ariaDescribedBy"
      [isOptional]="isOptional"
      [optionalText]="optionalText"
      [value]="value"
      (blur)="onTouched()"
      (input)="inputHandler($event.target.value)"
    ></leaf-textarea>
  `,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CignaLeafTextareaComponent),
      multi: true,
    },
  ],
})
export class CignaLeafTextareaComponent implements ControlValueAccessor {
  @Input() charLimit?: LeafTextarea['charLimit'];
  @Input() disabled?: LeafTextarea['disabled'];
  @Input() readonly?: LeafTextarea['readonly'];
  @Input() error?: LeafTextarea['error'];
  @Input() success?: LeafTextarea['success'];
  @Input() rows: LeafTextarea['rows'];
  @Input() cols: LeafTextarea['cols'];
  @Input() fieldNote?: LeafTextarea['fieldNote'];
  @Input() label: LeafTextarea['label'];
  @Input() type: LeafTextarea['type'] = 'text';
  @Input() fieldId?: LeafTextarea['fieldId'];
  @Input() ariaDescribedBy?: LeafTextarea['ariaDescribedBy'];
  @Input() isOptional?: LeafTextarea['isOptional'];
  @Input() optionalText?: LeafTextarea['optionalText'];

  @Output() change = new EventEmitter<string>();

  private _value = '';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onTouched: any = () => {};

  inputHandler(val: string) {
    this._value = val;
    this.onTouched();
    this.onChange(this._value);
    this.change.emit(val);
  }

  @Input()
  get value() {
    return this._value;
  }

  set value(val) {
    if (val !== this._value) {
      this._value = val;
      this.onTouched();
    }
  }

  writeValue(value: string) {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
